module.exports = __webpack_public_path__ + "static/ariel-nomad-tan-allstocksociety-600px-d24ff35172a75280c092d968a1776e42.jpg";